const types = {
    SET_CASE_LIST_LOADING: 'SET_CASE_LIST_LOADING',
    SET_PENDING_PRESCRIPTION_CASE_LIST: 'SET_PENDING_PRESCRIPTION_CASE_LIST',
    SET_CASE_COUNT_LOADING: 'SET_CASE_COUNT_LOADING',
    SET_PENDING_PRESCRIPTION_CASE_COUNT: 'SET_PENDING_PRESCRIPTION_CASE_COUNT',
};

export default types;